/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ExchangeTokenData } from "./ExchangeTokenData";
export const ExchangeTokenResponse = core.serialization.object({
    data: ExchangeTokenData,
});
